/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Sidebar_DiscoverInputs */

const en_directory_sidebar_discover = /** @type {(inputs: Directory_Sidebar_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore`)
};

const zh_directory_sidebar_discover = /** @type {(inputs: Directory_Sidebar_DiscoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`探索`)
};

/**
* | output |
* | --- |
* | "Explore" |
*
* @param {Directory_Sidebar_DiscoverInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_sidebar_discover = /** @type {((inputs?: Directory_Sidebar_DiscoverInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Sidebar_DiscoverInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_sidebar_discover(inputs)
	return zh_directory_sidebar_discover(inputs)
});
export { directory_sidebar_discover as "directory.sidebar.discover" }